// extracted by mini-css-extract-plugin
export var checked = "RadioBtn-module--checked--b7ff3";
export var fadeInAnimation = "RadioBtn-module--fadeInAnimation--dd340";
export var input = "RadioBtn-module--input--f9d0e";
export var mark = "RadioBtn-module--mark--373b7";
export var name = "RadioBtn-module--name--2811c";
export var radio = "RadioBtn-module--radio--2584a";